import { InformationTooltip, UIText1 } from '@cian/ui-kit';
import { IconFunctionalInformationCircle16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { NBSP } from 'shared/constants';
import { IBuilder, ISpecificationItem } from 'shared/types/newbuildingSpecifications';

import * as styles from './styles.css';
import { CardSectionNew } from '../CardSectionNew';
import { Link } from '../Link';

interface ISpecificationRow {
  title: string;
  content: React.ReactNode;
}

export const NewbuildingSpecifications = ({
  specifications,
  status,
  developer,
  brochure,
  name,
  titleChildren,
}: {
  specifications: ISpecificationItem[];
  status: string;
  developer: IBuilder | null;
  brochure: React.ReactNode;
  name: string;
  titleChildren?: React.ReactNode;
}) => {
  const rows: ISpecificationRow[] = [
    { title: 'Сдача комплекса', content: <UIText1>{status}</UIText1> },
    ...(developer && developer.url
      ? [
          {
            title: 'Застройщик',
            content: (
              <Link target="_blank" url={developer.url}>
                {developer.name}
              </Link>
            ),
          },
        ]
      : []),
    ...specifications.map(item => ({
      title: item.title,
      content: (
        <>
          <UIText1>{item.value || '-'}</UIText1>
          {item.valueTooltipText && (
            <InformationTooltip header={item.value} content={item.valueTooltipText} theme="white">
              <div className={styles['faq']} data-testid="NewbuildingSpecificationFaqIcon">
                <IconFunctionalInformationCircle16 color="icon-main-default" />
              </div>
            </InformationTooltip>
          )}
        </>
      ),
    })),
  ];

  const middle = Math.ceil(rows.length / 2);
  const columns = [rows.slice(0, middle), rows.slice(middle)].filter(column => column.length > 0);

  return (
    <CardSectionNew title={`О ЖК${NBSP}«${name}»`} titleChildren={titleChildren}>
      <div className={styles['columns']}>
        {columns.map((column, columnIndex) => (
          <div key={columnIndex} className={styles['column']} data-testid="NewbuildingSpecificationsColumn">
            {column.map(row => (
              <div key={row.title} className={styles['row']}>
                <div className={styles['label']}>
                  <UIText1 color="text-secondary-default">{row.title}</UIText1>
                </div>
                <div className={styles['value']}>{row.content}</div>
              </div>
            ))}
          </div>
        ))}
      </div>
      {brochure && <div className={styles['brochure']}>{brochure}</div>}
    </CardSectionNew>
  );
};
